import { useQuery as n } from "@tanstack/react-query";
import { getApiClient as o } from "./index.es267.js";
const m = ({
  queryKey: r,
  queryFn: t,
  token: e,
  environment: u,
  ...i
}) => n({
  queryKey: [e, ...r],
  queryFn: () => t(o({ token: e, environment: u }).apiClient),
  ...i
});
export {
  m as useAPIQuery
};
//# sourceMappingURL=index.es385.js.map
